import ninegrid from "../index.js";

export class nxI18nExt extends HTMLElement
{
	#enableHtml;
	#target;
	#key;
	#value;
	#datalist;
	#dataSource = [];
	#i18n;
	
	constructor () {
		super();
	};
	
	connectedCallback() {
		this.#enableHtml	= this.getAttribute("enable-html") == "true";
		this.#i18n			= this.getAttribute("i18n") || this.getAttribute("label") || this.getAttribute("message") || this.getAttribute("text");
		
		//console.log("1", this.#i18n);
		
		$(() => { this.#initialize(); });
	};
	
	refresh = () => {
		
		if (!this.#target) return;
		
		if (this.#i18n) {
			
			this.#target.innerHTML = i18next.t(this.#i18n);
		}
		else if (this.#dataSource.length > 0 && !ninegrid.isNull(this.#value)) {
			
			var index = this.#dataSource.findIndex(m => m[this.#key] == ninegrid.global.locale);
			if (index < 0) index = 0;
			
			this.#target.innerHTML = this.#dataSource[index][this.#value];
	
			$("datalist", this).remove();
			$(this).append(this.#datalist);
		}
	};
	
	#initialize = () => {

		this.#datalist = "<datalist>";
		this.querySelectorAll("datalist option").forEach((option,i) => {
			var o = {};
			for (var j = 0; j < option.attributes.length; j++) {
				//o[option.attributes[j].name] = option.attributes[j].value.replaceAll("<", "&lt;").replaceAll(">", "&gt;");//.replaceAll('&#34;',' ');
				o[option.attributes[j].name] = this.#enableHtml ? option.attributes[j].value : option.attributes[j].value.replaceAll("<", "&lt;").replaceAll(">", "&gt;");//.replaceAll('&#34;',' ');
				
				if (i == 0) {
					["locale","lang","key","code"].includes(option.attributes[j].name) ? this.#key = option.attributes[j].name : this.#value = option.attributes[j].name;
				}
			}
			
			this.#datalist += "<option";
			for (const prop in o) {
				this.#datalist += ` ${prop}="${o[prop]}"`;
			}
			this.#datalist += "></option>";

			this.#dataSource.push(o);
		});
		this.#datalist += "</datalist>";
		

		const s = this.innerHTML;
		
		this.innerHTML = `
			<span>${s}</span>
		`;
		
		this.#target = this.querySelector("span");
		
		for (var i = 0; i < this.attributes.length; i++) {
			this.#target.setAttribute(this.attributes[i].name, this.attributes[i].value);
		}
		
		this.refresh();
	};
	
	static i18n = {
		convertArrayToJSON : (arr) => {
			let result = {};
			
			for (const str of arr) {
				
				if (!str) continue;
				
				const index = str.indexOf("=");
				if (index <= 0) continue;
				
				const keys = str.substring(0, index).split('.');
				const value = str.substring(index+1);
				let current = result;
				
				for (let i = 0; i < keys.length; i++) {
					if (i === keys.length - 1) {
						current[keys[i]] = value;
					}
					else {
						if (!current[keys[i]]) {
							current[keys[i]] = {};
						}
						current = current[keys[i]];
					}
				}
			}
		
			return result;
		},
		updateContent : () => {
			ninegrid.querySelectorAll("nx-i18n,nx-span").forEach(v => {
				if (v.refresh) v.refresh();
			});
			ninegrid.querySelectorAll("nine-grid").forEach(v => {
				if (v.refresh) v.refreshData();
			});
		},
		addResourceBundle : (args) => {
			console.log("********************", args);
			
			let count = Math.floor(args.length / 2);
			
			for (var i=0; i < args.length; i+=2) {
				//console.log(i, args.length);
				if (i+1 >= args.length) break;
				
				const locale = args[i];
				const fileNm = args[i+1];
				
				/**
				$.ajax({
					url: fileNm,	// "/properties/message.ko.prop",
					dataType: "text",
					success: (text) => {
						i18next.addResourceBundle(locale, 'translation', ninegrid.i18n.convertArrayToJSON(text.split("\n")));
						
						if (--count == 0) i18next.changeLanguage(ninegrid.global.locale);
					}
				}); */
				var xhr = new XMLHttpRequest();
				xhr.open("GET", fileNm, false); // false로 설정하여 동기식 요청으로 만듭니다.
				xhr.send();

				if (xhr.status === 200) {
				    var text = xhr.responseText;
				    i18next.addResourceBundle(locale, 'translation', ninegrid.i18n.convertArrayToJSON(text.split("\n")));
				    
				    // 마지막 파일인 경우 화면갱신
				    if (--count == 0) {
				        i18next.changeLanguage(ninegrid.global.locale);
				    }
				}

			}
			
			console.log("=========");
			//ninegrid.i18n.updateContent();
		},
		
	}
}

if (!customElements.get('nx-i18n')) {
	customElements.define("nx-i18n", nxI18nExt);
}

